import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteATourismPolicy, getTourismPolicys, resetState } from "../features/TourismPolicySclice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const TourismPolicylist = () => {
  const [open, setOpen] = useState(false);
  const [TourismPolicyId, setTourismPolicyId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setTourismPolicyId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getTourismPolicys());
  }, []);
  const getTourismPolicyState = useSelector((state) => state.tourismPolicy.TourismPolicys);
  console.log(getTourismPolicyState);
  const data1 = [];
  console.log(getTourismPolicyState.length);
  for (let i = 0; i < getTourismPolicyState.length; i++) {
    data1.push({
      key: i + 1,
      name: getTourismPolicyState[i].policyName,

      action: (
        <>
          <Link
            to={`/ppp/Add-Tourism-Policy/${getTourismPolicyState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getTourismPolicyState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteATourismPolicy(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getTourismPolicys());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">Tourism Policy List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(TourismPolicyId);
        }}
        title="Are you sure you want to delete this Tourism Policy?"
      />
    </div>
  );
};

export default TourismPolicylist;
